import PropTypes from 'prop-types';

export default function Divider({divide = 1, gap = 0, height = 1, color = 'black', margin = 0}) {
  return (
    <div
      style={{
        height: `${height}`,
        width: `calc(100% - ${margin * 2}px)`,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: `${gap}px`,
        margin: `0 ${margin}px`,
      }}
    >
      {[...Array(divide)].map((_) => (
        <div
          key={_}
          style={{
            height: '100%',
            width: '100%',
            backgroundColor: color,
          }}
        />
      ))}
    </div>
  );
}

Divider.propTypes = {
  divide: PropTypes.number.isRequired,
  gap: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  margin: PropTypes.number.isRequired,
};
